import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { SUBSCRIPTIONS } from '../apiUrls';
import subscriptionFields from '../../fields/subscriptionFields';

const mutationScheduledTerminateSubscription = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionId, resiliationDate }) => {
            return client.post(
                replaceParameters(SUBSCRIPTIONS.SCHEDULED_TERMINATE.url, { subscriptionId: subscriptionId }),
                { [subscriptionFields.RESILIATION_DATE.key]: resiliationDate }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationScheduledTerminateSubscription;